import { AnimatePresence, motion } from 'motion/react';
import { CheckCircle2 } from 'lucide-react';

interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PaymentSuccessModal({ isOpen, onClose }: PaymentSuccessModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-6 pointer-events-none">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm pointer-events-auto"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="relative w-full max-w-sm bg-white dark:bg-zinc-900 p-8 rounded-[32px] shadow-2xl border border-emerald-100 dark:border-zinc-800 text-center space-y-6 pointer-events-auto"
          >
            <div className="w-20 h-20 bg-emerald-500 rounded-full flex items-center justify-center mx-auto shadow-xl shadow-emerald-200 dark:shadow-emerald-900/20 mb-2">
              <CheckCircle2 className="text-white w-10 h-10" />
            </div>
            <div className="space-y-2">
              <h2 className="text-2xl font-bold text-zinc-900 dark:text-zinc-100">Welcome to Premium!</h2>
              <p className="text-sm text-zinc-500 dark:text-zinc-400 leading-relaxed">
                Your subscription is active. You now have unlimited access to all features.
              </p>
            </div>
            <button 
              onClick={onClose}
              className="w-full py-4 bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 rounded-2xl font-bold shadow-lg active:scale-95 transition-transform"
            >
              Start Using App
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}